export const DAY_ID = 'dayId';
export const OVERNIGHT_ID = 'overnightId';

export const reservationMappings = {
  [DAY_ID]: 'Day',
  [OVERNIGHT_ID]: 'Overnight',
};
